import React from 'react';
export function ReservationWidget() {
  return null;
}